<div class="container">
    <div *ngIf="isLoading" class="row center">
        <div class="spinner-border text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div *ngIf="!isLoading" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
            <div class="col-md-12 col-xs-12">
                <h2>All Fancy for {{ id }}</h2>
            </div>
            <div class="col-md-12 col-xs-12 mtop">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fancy Name</th>
                                <th class="layyes">No</th>
                                <th class="backno">Yes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let afancy of afdata; let i = index">
                                <td>{{ i+1 }}</td>
                                <td>{{ afancy.nat }}</td>
                                <td *ngIf="afancy.gstatus != ''" colspan="2" class="ballR">Ball Running</td>
                                <td *ngIf="afancy.gstatus == ''" class="layyes">{{ afancy.l1 }} <br> {{ afancy.ls1 }}
                                </td>
                                <td *ngIf="afancy.gstatus == ''" class="backno">{{ afancy.b1 }} <br> {{ afancy.bs1 }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>